// Tempo real: um EventSource por aba (/api/live). O servidor só diz "o regulador X mudou,
// tipo Y"; aqui isso vira invalidação das consultas na tela, que rebuscam pela API normal.
// O EventSource reconecta sozinho se a conexão cair.

import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const SERIES_MIN_INTERVAL = 5_000;

interface Change {
  kind: string;
  regulatorId: number;
}

export function useLiveUpdates() {
  const qc = useQueryClient();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const lastSeries = new Map<number, number>();
    const es = new EventSource("/api/live");
    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);
    es.onmessage = (ev) => {
      let c: Change;
      try {
        c = JSON.parse(ev.data);
      } catch {
        return;
      }
      qc.invalidateQueries({ queryKey: ["live", c.regulatorId] });
      if (c.kind === "link" || c.kind === "meta") {
        qc.invalidateQueries({ queryKey: ["regulator", c.regulatorId] });
        qc.invalidateQueries({ queryKey: ["tree"] });
      }
      if (c.kind === "alarm" || c.kind === "alarms_state") qc.invalidateQueries({ queryKey: ["alarms"] });
      // A Visão geral acompanha as grandezas pelo intervalo; link e alarme, na hora.
      if (c.kind !== "electrical" && c.kind !== "status") qc.invalidateQueries({ queryKey: ["dashboard"] });
      // A série inteira é pesada e as leituras chegam a cada segundo: no máximo uma busca
      // a cada 5 s por regulador (o gráfico acompanha sem rebuscar a janela toda sem parar).
      if (c.kind === "electrical") {
        const now = Date.now();
        if (now - (lastSeries.get(c.regulatorId) ?? 0) >= SERIES_MIN_INTERVAL) {
          lastSeries.set(c.regulatorId, now);
          qc.invalidateQueries({ queryKey: ["series-live", c.regulatorId] });
        }
      }
    };
    return () => es.close();
  }, [qc]);

  return connected;
}
